import { FieldViewModel, IOmniaShell, IUibModalScope, shell } from "../../omnia";

export class AllocPopupBase<T> extends shell.Dialog {

    public selectedItems: T[];
    public availableItems: T[];
    public filtredItems: T[];

    protected field: FieldViewModel;
    protected search: string;

    constructor($scope: ng.IScope, shell: IOmniaShell, public name: string, public showSearch: boolean = false) {

        super($scope, shell);
        this.$scope = <IUibModalScope>$scope.$parent;

        this.field = this.arguments;

        if (showSearch) {
            $scope.$watch(() => this.search, () => this.filter());
        }

    }

    get title(): string {
        return "Manage " + this.field.description + " allocations";
    }

    protected filter() {
        if (!this.search) {
            this.filtredItems = this.availableItems.slice();
            return;
        }

        this.filtredItems = this.availableItems.filter(a => this.getDescription(a).toLowerCase().indexOf(this.search.toLowerCase()) !== -1);
    }

    protected getDescription(item: T): string {
        return "Not implemented";
    }

    protected selectItem(item: T) {
        if (item && this.selectedItems.indexOf(item) === -1) {
            this.selectedItems.push(item);
            this.availableItems = this.availableItems.filter(a => a !== item);
            this.filter();
        }
    }

    protected unselectItem(item: T) {
        if (item && this.selectedItems.indexOf(item) !== -1) {
            this.selectedItems = this.selectedItems.filter(a => a !== item);
            this.availableItems.push(item);
            this.filter();
        }
    }

}
